import { VERSION } from "./lib/utils/version.js";
import { encodeTWKB } from "./lib/encode-twkb.js";
export const TWKBWriter = {
  name: 'TWKB (Tiny Well Known Binary)',
  id: 'twkb',
  module: 'wkt',
  version: VERSION,
  extensions: ['twkb'],
  encode: async (geometry, options) => encodeTWKB(geometry, options === null || options === void 0 ? void 0 : options.twkb),
  encodeSync: (geometry, options) => encodeTWKB(geometry, options === null || options === void 0 ? void 0 : options.twkb),
  options: {
    twkb: {
      hasZ: false,
      hasM: false
    }
  }
};
//# sourceMappingURL=twkb-writer.js.map